<template>
  <div class="container">
    <div class="content">
      <div class="anchor2">
        <div @click="show=!show" class="clickArea">{{$t('m.OnThisPage')}}<i class="el-icon-arrow-down"></i> </div>
        <div v-if="show">
          <p @click="activeted(1)" class="s1"><a :class="{active:flag==1}" href="#box1">委托人提现质押币到账时间</a></p>
          <p @click="activeted(2)" class="s1"><a :class="{active:flag==2}" href="#box2">什么是委托人</a></p>
          <p @click="activeted(3)" class="s1"><a :class="{active:flag==3}" href="#box3">投票动机</a></p>
          <p @click="activeted(4)" class="s1"><a :class="{active:flag==4}" href="#box4">选择验证器</a></p>
          <p @click="activeted(5)" class="s1"><a :class="{active:flag==5}" href="#box5">委托人指令</a></p>
          <!-- <div class="subAnchor">
            <p @click="activeted(2)" class="s2"><a :class="{active:flag==2}" href="#box2">TLS Certificates</a></p>
            <p @click="activeted(3)" class="s2"><a :class="{active:flag==3}" href="#box3">TLS Addresses</a></p>
    
          </div> -->
        </div>
      </div>
      <div class="p1">委托人常见问题解答</div>
      <div id="box1" class="p4">委托人提现质押币到账时间</div>
      <div class="p3">21 天到账。第 1 笔提现未到账的 21 天内又进行第 2 笔提现，则第 1，2 笔到账时间将统一跟新到第 2 笔到账的 21 天。</div>
      <div id="box2" class="p4">什么是委托人</div>
      <div class="p3">代币持有者可以通过“委托”命令获得投票，并选择他们认为对生态系统有意义的验证者。这些代币持有者被称为委托人。</div>
      <div class="p3">委托人在系统中扮演着至关重要的角色，因为他们负责选择验证人。作为委托人不是被动的角色：委托人应积极监控其验证人的行为并参与治理。</div>
      <div id="box3" class="p4">投票动机</div>
      <div class="p3">投票是代币持有者参与链上治理的主要方式。你希望网络上的验证者具有很强的技术能力，因为如果出现新功能，验证者将决定网络的方向，他们需要快速有效地做出反应。</div>
      <div class="p3">另一方面，还有社区生态系统方面。如果有任何问题或需要讨论的主题，验证者需要一起工作。他们需要能够一起工作、合作并始终保持高度透明。</div>
      <div class="p3">您可以选择是否要成为 Fax 生态系统的委托人。网络的未来可能取决于你的选票和管理它的人。</div>
      <div id="box4" class="p4">选择验证器</div>
      <div class="p3">为了选择他们的验证人，委托人可以直接在区块浏览器上访问一系列信息。</div>
      <div class="p3">
        <ul style="padding-left:30px">
          <li>Validator's moniker：验证人候选人的姓名。</li>
          <li>Validator's description：验证器操作员提供的描述。</li>
          <li>验证者网站：链接到验证者网站。</li>
        </ul>
      </div>
      <div id="box5" class="p4">委托人指令</div>
      <div class="p3">成为委托人并不是一项被动的任务。以下是委托人的主要指令：</div>
      <div class="p3">
        <ul style="padding-left:30px">
          <li>在委派之前对验证者进行仔细的尽职调查。如果验证者行为不端，他们的总股份的一部分，包括其委托人的股份，可能会被削减。因此，委托人应该仔细选择他们认为行为正确的验证人。</li>
          <li>委托后积极监控他们的验证者。委托人应确保他们委托的验证人行为正确，这意味着他们有良好的正常运行时间，不会双重签名或受到损害，并在治理过程中保持活跃。他们还应该监控适用的佣金率。如果委托人对其验证人不满意，他们可以解绑或切换到另一个验证人（注意：委托人不必等待解绑期间切换验证人。重新绑定立即生效）。</li>
          <li>参与治理。委托人可以并且被期望积极参与治理。委托人的投票权与其抵押股份的大小成正比。如果委托人不投票，他们将继承其验证人的投票。如果他们确实投票，他们会推翻其验证者的投票。因此，委托人充当其验证人的制衡角色。</li>
        </ul>
      </div>
      
    </div>
    <div class="wrapper">
    <div class="anchor1">
      <p @click="activeted(1)" class="s1"><a :class="{active:flag==1}" href="#box1">委托人提现质押币到账时间</a></p>
      <p @click="activeted(2)" class="s1"><a :class="{active:flag==2}" href="#box2">什么是委托人</a></p>
      <p @click="activeted(3)" class="s1"><a :class="{active:flag==3}" href="#box3">投票动机</a></p>
      <p @click="activeted(4)" class="s1"><a :class="{active:flag==4}" href="#box4">选择验证器</a></p>
      <p @click="activeted(5)" class="s1"><a :class="{active:flag==5}" href="#box5">委托人指令</a></p>
      <!-- <div class="subAnchor">
        <p @click="activeted(2)" class="s2"><a :class="{active:flag==2}" href="#box2">TLS Certificates</a></p>
        <p @click="activeted(3)" class="s2"><a :class="{active:flag==3}" href="#box3">TLS Addresses</a></p>

      </div> -->
    </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CryptographicPrimitives',
  data() {
    return {
      flag: 1,
      show: false
    }
  },
  methods: {
    activeted(i) {
      console.log('i',i);
      this.flag = i
    }
  },
  mounted() {
    window.scroll(0, 0)
  }
}
</script>


<style lang="sass" scoped>
@media screen and (min-width:980px)
  .container
    display: flex
    .content
      width: 78%
      padding: 10px 6px
      .p1
        padding: 20px 0
        font-size: 50px
        font-weight: 700
        line-height: 60px
      .p2
        padding: 20px 0
        font-size: 35px
        font-weight: 700
        line-height: 40px
      .p4
        padding: 20px 0
        font-size: 26px
        font-weight: 700
        line-height: 30px
      .p3
        line-height: 25px
        padding-bottom: 15px
    .anchor2
      display: none
    .wrapper
      width: 22%
    .anchor1
      position: sticky
      top: 0px
      right: 0px
      padding: 0 15px
      padding-right: 0
      // width: 18%
      color: #525860
      font-size: 14px
      border-left: 1px solid #DADDE1
      .active  
        color: #7549A9
      .subAnchor
        padding: 0 15px
      a
        color: #525860
      a:hover
        color: #7549A9
        font-size: 15px
      .s1
        margin: 10px 0
        line-height: 20px
        cursor: pointer
      .s2
        margin: 10px 0
        line-height: 20px
        cursor: pointer
        // word-break: break-all
@media screen and (max-width:980px)
  .container
    display: flex
    .content
      // width: 75%
      padding: 10px 6px
      .p1
        padding: 20px 0
        font-size: 50px
        font-weight: 700
        line-height: 60px
      .p2
        padding: 20px 0
        font-size: 35px
        font-weight: 700
        line-height: 40px
        padding-top: 60px
        margin-top: -60px
      .p4
        padding: 20px 0
        font-size: 26px
        font-weight: 700
        line-height: 30px
        padding-top: 60px
        margin-top: -60px
      .p3
        line-height: 25px
        padding-bottom: 15px
    .anchor1
      display: none
    .anchor2
      background: #F2F2F2
      border-radius: 5px
      color: #000
      padding: 10px 15px
      padding-right: 0
      // width: 25%
      font-size: 16px
      .clickArea
        padding-right: 15px
        color: #000
        display: flex
        justify-content: space-between
      .active  
        color: #7549A9
      .subAnchor
        padding-left: 15px
      a
        color: #525860
      a:hover
        color: #7549A9
      .s1
        margin: 10px 0
        line-height: 20px
        cursor: pointer
      .s2
        margin: 10px 0
        line-height: 20px
        cursor: pointer
        // word-break: break-all
</style>